import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const filterDefaultVariants = {}
const filterCompoundVariants = []

const filterSlotNames = [
  [
    "accordionHeader",
    "filter__accordionHeader"
  ],
  [
    "accordionTrigger",
    "filter__accordionTrigger"
  ],
  [
    "accordionTriggerLabel",
    "filter__accordionTriggerLabel"
  ],
  [
    "accordionPanel",
    "filter__accordionPanel"
  ],
  [
    "accordionItem",
    "filter__accordionItem"
  ],
  [
    "accordionItemRight",
    "filter__accordionItemRight"
  ],
  [
    "accordionCount",
    "filter__accordionCount"
  ],
  [
    "accordionLabel",
    "filter__accordionLabel"
  ]
]
const filterSlotFns = /* @__PURE__ */ filterSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, filterDefaultVariants, getSlotCompoundVariant(filterCompoundVariants, slotName))])

const filterFn = memo((props = {}) => {
  return Object.fromEntries(filterSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const filterVariantKeys = []
const getVariantProps = (variants) => ({ ...filterDefaultVariants, ...compact(variants) })

export const filter = /* @__PURE__ */ Object.assign(filterFn, {
  __recipe__: false,
  __name__: 'filter',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: filterVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, filterVariantKeys)
  },
  getVariantProps
})